module.exports = __webpack_public_path__ + "img/6.c33b9a6c.png";